// extracted by mini-css-extract-plugin
var _1 = "trrjpD9uJd";
var _2 = "DUsJFvE_k9";
export { _1 as "frame", _2 as "keyboard" }
